import { render, staticRenderFns } from "./ModalCheckMatchingProducts.vue?vue&type=template&id=3cfc1c58&scoped=true&"
import script from "./ModalCheckMatchingProducts.vue?vue&type=script&lang=js&"
export * from "./ModalCheckMatchingProducts.vue?vue&type=script&lang=js&"
import style0 from "./ModalCheckMatchingProducts.vue?vue&type=style&index=0&id=3cfc1c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc1c58",
  null
  
)

export default component.exports